<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 17/07/28. -->

<template>
  <div>
    <v-progress-linear
      v-if="linear"
      :indeterminate="indeterminate"
      :background-color="backgroundColor"
      :color="color"
      :value="progressValue"
      :height="width"
      :style="linearProgressStyle">
    </v-progress-linear>

    <v-progress-circular
      v-else
      :indeterminate="indeterminate"
      :background-color="backgroundColor"
      :color="color"
      :value="progressValue"
      :size="size"
      :width="width">
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "WeexProgress",

  data: () => ({
    progressValue: 0
  }),

  props: {
    linear: {
      type: Boolean,
      default: true,
    },

    indeterminate: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Number,
      required: true,
      default: 0
    },

    backgroundColor: {
      type: String,
      default: "white"
    },

    color: {
      type: String,
      default: "blue"
    },

    width: {
      type: Number,
      default: 5
    },

    //size is required only for circular progress
    size: {
      type: Number,
      default: 48
    },

    //rounded is required only for linear progress
    rounded: {
      type: Boolean,
      default: true
    },

    //borderColor is required only for linear progress
    borderColor: {
      type: String,
      default: ""
    }
  },

  computed: {
    linearProgressStyle() {
      let style = {}
      if (this.rounded) {
        style["border-radius"] = this.width / 2 + "px"
      }
      if (this.borderColor) {
        style["border-color"] = this.borderColor
        style["border-style"] = "solid"
        style["border-width"] = "1px"
      }
      return style
    }
  },

  watch: {
    value() {
      if (this.indeterminate) {
        this.progressValue = 0
      } else {
        this.progressValue = this.value
      }
    }
  }
}
</script>
